













































































































































import { Component, Vue } from "vue-property-decorator";
import {
  FormBuilderConfig,
  FormBuilderField,
  FormBuilderTab,
  SelectedField,
} from "./types/FormBuilderTypes";
import { ComponentsTypes } from "@/components/DinamicallyForm/TipoComponentes";
import ComponentPalette from "./components/ComponentPalette.vue";
import FormCanvas from "./components/FormCanvas.vue";
import PropertiesPanel from "./components/PropertiesPanel.vue";

@Component({
  components: {
    ComponentPalette,
    FormCanvas,
    PropertiesPanel,
  },
})
export default class FormBuilderMain extends Vue {
  public formConfig: FormBuilderConfig = {
    formName: "Nuevo Formulario",
    tabs: [{ tabNumber: 1, tabName: "General" }],
    fields: [],
    apiConfig: {
      getEndpoint: "",
      saveEndpoint: "",
      deleteEndpoint: "",
    },
  };

  public selectedField: SelectedField = {
    field: null,
    index: -1,
  };

  public exportDialog: boolean = false;
  public importDialog: boolean = false;
  public exportedJson: string = "";
  public importJson: string = "";

  private draggedComponentType: ComponentsTypes | null = null;
  private editingFormId: string | null = null;

  public created() {
    // Check if we're editing an existing form
    const editingForm = sessionStorage.getItem("formBuilder_editing");
    if (editingForm) {
      const form = JSON.parse(editingForm);
      this.formConfig = form;
      this.editingFormId = form.id;
      sessionStorage.removeItem("formBuilder_editing");
    }
  }

  public beforeDestroy() {
    // Clean up session storage
    sessionStorage.removeItem("formBuilder_editing");
  }

  public onDragStart(componentType: ComponentsTypes) {
    this.draggedComponentType = componentType;
  }

  public onDrop(event: any) {
    if (this.draggedComponentType === null) return;

    const newField: FormBuilderField = this.createDefaultField(
      this.draggedComponentType
    );
    this.formConfig.fields.push(newField);
    this.draggedComponentType = null;
  }

  public onSelectField(fieldId: string) {
    const index = this.formConfig.fields.findIndex((f) => f.id === fieldId);
    if (index !== -1) {
      this.selectedField = {
        field: this.formConfig.fields[index],
        index,
      };
    }
  }

  public onUpdateField(updatedField: FormBuilderField) {
    if (this.selectedField.index !== -1) {
      this.$set(this.formConfig.fields, this.selectedField.index, updatedField);
      this.selectedField.field = updatedField;
    }
  }

  public onReorder(newOrder: FormBuilderField[]) {
    this.formConfig.fields = newOrder;
  }

  public onDeleteField(fieldId: string) {
    const index = this.formConfig.fields.findIndex((f) => f.id === fieldId);
    if (index !== -1) {
      this.formConfig.fields.splice(index, 1);
      if (this.selectedField.field && this.selectedField.field.id === fieldId) {
        this.selectedField = { field: null, index: -1 };
      }
    }
  }

  public onAddTab(tabName: string) {
    const newTab: FormBuilderTab = {
      tabNumber: this.formConfig.tabs.length + 1,
      tabName,
    };
    this.formConfig.tabs.push(newTab);
  }

  public onUpdateFormApi(apiConfig: any) {
    this.formConfig.apiConfig = apiConfig;
  }

  public openPreview() {
    // Store current form config in sessionStorage for preview
    sessionStorage.setItem(
      "formBuilder_preview",
      JSON.stringify(this.formConfig)
    );

    // Open preview in new tab
    const previewUrl = this.$router.resolve({
      name: "form_builder_preview",
    }).href;
    window.open(previewUrl, "_blank");
  }

  public async saveForm() {
    if (!this.formConfig.formName.trim()) {
      alert("Por favor ingresa un nombre para el formulario");
      return;
    }

    try {
      // TODO: Replace with actual API call
      // const response = await api.post('/form-definitions', this.formConfig);

      // Temporary: Save to localStorage
      const savedForms = localStorage.getItem("formBuilder_forms");
      let forms = savedForms ? JSON.parse(savedForms) : [];

      const formWithMeta = {
        ...this.formConfig,
        id: this.editingFormId || this.generateId(),
        createdAt: this.editingFormId
          ? (() => {
              const existingForm = forms.find(
                (f: any) => f.id === this.editingFormId
              );
              return existingForm
                ? existingForm.createdAt
                : new Date().toISOString();
            })()
          : new Date().toISOString(),
        updatedAt: new Date().toISOString(),
      };

      if (this.editingFormId) {
        // Update existing
        const index = forms.findIndex((f: any) => f.id === this.editingFormId);
        if (index !== -1) {
          forms[index] = formWithMeta;
        }
      } else {
        // Create new
        forms.push(formWithMeta);
      }

      localStorage.setItem("formBuilder_forms", JSON.stringify(forms));

      alert(
        this.editingFormId
          ? "Formulario actualizado correctamente"
          : "Formulario guardado correctamente"
      );

      this.goBack();
    } catch (error) {
      console.error("Error saving form:", error);
      alert("Error al guardar el formulario");
    }
  }

  public goBack() {
    this.$router.push({ name: "form_builder_list" });
  }

  public exportForm() {
    this.exportedJson = JSON.stringify(this.formConfig, null, 2);
    this.exportDialog = true;
  }

  public importForm() {
    try {
      const imported = JSON.parse(this.importJson);
      this.formConfig = imported;
      this.importDialog = false;
      this.importJson = "";
    } catch (error) {
      alert("Error al importar: JSON inválido");
    }
  }

  public clearForm() {
    if (confirm("¿Estás seguro de que quieres limpiar todo el formulario?")) {
      this.formConfig = {
        formName: "Nuevo Formulario",
        tabs: [{ tabNumber: 1, tabName: "General" }],
        fields: [],
        apiConfig: {
          getEndpoint: "",
          saveEndpoint: "",
          deleteEndpoint: "",
        },
      };
      this.selectedField = { field: null, index: -1 };
    }
  }

  public copyToClipboard() {
    navigator.clipboard.writeText(this.exportedJson);
    alert("JSON copiado al portapapeles");
  }

  private generateId(): string {
    return `form_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  private createDefaultField(type: ComponentsTypes): FormBuilderField {
    const baseId = `field_${Date.now()}_${Math.random()
      .toString(36)
      .substr(2, 9)}`;

    const baseField: FormBuilderField = {
      id: baseId,
      caption: "Nuevo Campo",
      variableName: baseId,
      datatype: "string",
      componentType: type,
      defaultValue: null,
      required: false,
      readonly: false,
      visible: true,
      mayuscula: false,
      maxLength: 100,
      icon: "",
      validacion: "",
      dim_cols: 12,
      dim_sm: 6,
      dim_md: 4,
      intab: 1,
    };

    // Configuración específica por tipo
    switch (type) {
      case ComponentsTypes.Date:
      case ComponentsTypes.DateTime:
        baseField.datatype = "date";
        break;
      case ComponentsTypes.Switch:
        baseField.datatype = "boolean";
        baseField.switchOn = "Sí";
        baseField.switchOff = "No";
        break;
      case ComponentsTypes.TextArea:
        baseField.dim_cols = 12;
        baseField.dim_sm = 12;
        baseField.dim_md = 12;
        break;
      case ComponentsTypes.SingleCombo:
      case ComponentsTypes.MultiCombo:
        baseField.comboConfig = {
          dataSource: [],
          displayExpr: "text",
          valueExpr: "value",
        };
        break;
      case ComponentsTypes.RadioButton:
        baseField.radioOptions = [];
        break;
    }

    return baseField;
  }
}
